Application.CategoryList = {
    ui: {
        container: '.js-category-list',
        category: '.js-category-list__category',
        item: '.js-category-list__item',
    },
    ready: function () {

        var self = this;

        if (!$(this.ui.container).length){
            return;
        }

        // bind
        $(document).on('click', this.ui.category, function(e){
            e.preventDefault();
            self.show($(this).closest(self.ui.container), $(this).attr('data-category-id'));
        });
        // init
        $(this.ui.container).each(function(){
            // find active item
            var $active = $(this).find(self.ui.item + ' input:checked').closest(self.ui.item).attr('data-category-id');
            // find first category
            var $first = $(this).find(self.ui.category).first().attr('data-category-id');
            // activate the selected category or first if none item selected
            self.show($(this), $active.length? $active : $first);
        });

    },
    show: function($container, categoryId){

        // deactivate all
        var $categories = $container.find(this.ui.category);
        var $items = $container.find(this.ui.item);
        $categories.removeClass('js-category-list__category--active');
        $items.removeClass('js-category-list__item--active');

        // activate selected category
        $categories.filter('[data-category-id="' + categoryId + '"]').addClass('js-category-list__category--active');
        $items.filter('[data-category-id="' + categoryId + '"]').addClass('js-category-list__item--active');

    }
};